<template>
  <v-app id="root">
    <v-app-bar app dark dense color="primary" class="app-header">
      <v-toolbar-title class="d-none d-sm-flex">
        {{ name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="$route.path !== '/home'" outlined class="text-normal d-none d-sm-flex" @click="home()">
        Inicio
        <v-icon right>mdi-home</v-icon>
      </v-btn>
      <v-btn v-if="$route.path !== '/home'" small outlined class="text-normal d-flex d-sm-none" @click="home()">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text class="text-normal d-none d-sm-flex">
        {{ username }}
        <v-icon right>mdi-account</v-icon>
      </v-btn>
      <v-btn outlined class="text-normal d-none d-sm-flex" @click="logout()">
        Salir
        <v-icon right>mdi-logout</v-icon>
      </v-btn>
      <v-btn small outlined class="text-normal d-flex d-sm-none" @click="logout()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import mainFooter from '@/components/Footer'

export default {
  name: 'root',
  components: { mainFooter },
  data: () => ({
    host: process.env.VUE_APP_API_SERVER,
    version: process.env.VUE_APP_VERSION,
    name: process.env.VUE_APP_NAME,
    path: '/api/logout',
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',
    logo: require('@/assets/logo.png'),
    username: '',
  }),
  mounted() {
    this.check()
  },
  methods: {
    check() {
      this.username = this.$session.get('usr')
    },
    logout() {
      this.loading = true
      if (this.$session.exists()) {
        this.axios.post(this.host + this.path)
          .then(response => {
            this.$session.destroy()
            this.$router.push('/login')
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$router.push('/login')
      }
    },
    home() {
      if (this.$route.path !== '/home') {
        this.$router.push('/home')
      }
    }
  }
}
</script>

<style scoped>
  .app-header {
    z-index: 99;
  }
  .app-sidemenu {
    z-index: 99;
  }
  .text-normal {
    text-transform: none !important;
  }
</style>
